<template>
    <v-container max-width="100%" style="margin-top: 2%">

      <template>
      <v-row justify="center">
        <v-dialog
          v-model="progressoDialog"
          persistent
          max-width="500"
          style="height: 300px; z-index: 90000"
        >
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <h3 style="margin-top: 20px; color: #1565c0">
                  {{ this.mensagemProgressoDialog }}
                </h3>
              </v-row>

              <v-row justify="center">
                <v-progress-circular
                  :size="50"
                  :width="5"
                  color="primary"
                  indeterminate
                  style="margin-top: 10px; margin-bottom: 10px"
                ></v-progress-circular>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog
      v-model="dialogRelatorio"
      fullscreen
      max-width="100%"
      max-height="100%"
      style="z-index: 8000"
    >
      <DetalhesViagem
        ref="detalheViagem"
        :viagem="editedItem"
        :user="user"
        :token="token"
        :key="relatorioKey"
        @close="closeRelatorio"
      ></DetalhesViagem>
    </v-dialog>
  
      <v-container class="toolbar__container">
        <v-form ref="form" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-autocomplete
                v-model="idEmpresaSelected"
                :items="empresas"
                item-text="razao_social"
                item-value="id_empresa"
                clearable
                :label="$tc('company.self', 1)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                :label="$t('delayByGeofence.startDate')"
                v-model="dti"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                :date-picker-props="dtiProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker
              :label="$t('speedReport.endDate')"
              v-model="dtf"
              :time-picker-props="timeProps"
              :text-field-props="textFieldProps"
              :date-picker-props="dtfProps"
              time-format="HH:mm:ss"
              date-format="dd/MM/yyyy"
              :clear-text="$t('datetime.close')"
            >
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="3" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <MultiplaEscolha
                ref="linhasSelect"
                lazy
                get-url="getLinhaslazy"
                :request-data="lazySelectRequestData"
                v-bind:selected-items.sync="idLinhaSelected"
                text="nome_linha"
                value="id_linha"
                :label="$t('segments.headers.line')"
                :max-items="2"
              />
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <MultiplaEscolha
                ref="funcionariosSelect"
                lazy
                get-url="getFuncionarioslazy"
                :request-data="lazySelectRequestData"
                v-bind:selected-items.sync="idFuncionarioSelected"
                text="descricao"
                value="id_funcionario"
                :label="$tc('employee.self', 1)"
                :max-items="2"
              />
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <MultiplaEscolha
                ref="veiculosSelect"
                lazy
                get-url="getVeiculoslazy"
                :request-data="lazySelectRequestData"
                v-bind:selected-items.sync="idVeiculoSelected"
                text="numero_ordem"
                value="id_veiculo"
                :label="$t('fields.vehicle')"
                :max-items="2"
              />
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <MultiplaEscolha
                lazy
                get-url="getUnidadeslazy"
                :items="semUnidadeOption"
                v-bind:selected-items.sync="unidadesSelecionadas"
                text="descricao_unidade"
                value="id_unidade"
                :label="$t('nav.registration.units')"
                :max-items="2"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-container>

      <v-expansion-panels style="margin-bottom: 10px; border-radius: 10px; margin-top: 10px;">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <h3 style="color: #4a4a4a">{{ $t('routeCompliance.aggregates') }}</h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs
              v-model="tab"
              @change="buildHeader"
            >
              <v-tab>{{ $t('fields.vehicle') }}</v-tab>
              <v-tab>{{ $t('segments.headers.line') }}</v-tab>
              <v-tab>{{ $tc('employee.self', 2) }}</v-tab>
            </v-tabs>

            <merus-data-table
              :headers="headersAgregadoWithProperties"
              :items="agregado"
              sort-by="id_veiculo"
              dense
              class="elevation-7"
              locale="pt"
              :loading="loadingAgregado"
              :loading-text="$t('system.messages.loading')"
              style="border-radius: 10px; margin-bottom: 10px;"
              @update:headers="headersAgregadoWithProperties = $event"
            >
              <template v-slot:toolbar>
                  <CadastroToolbar
                      :title="$t('routeCompliance.aggregates')"
                      :token="token"
                      :items="agregado"
                      csv-title="cumprimentoderotaagregado"
                      :pdf-title="$t('routeCompliance.title')"
                      :pdf-headers="headersAgregadoWithProperties"
                      pdf-filename="cumprimentoderotaagregado"
                      hide-search
                  >
                      <template v-slot:add>
                          <v-switch
                            v-model="porDia"
                            :label="$t('routeCompliance.perDay')"
                            color="primary"
                            @change="togglePorDia"
                            style="margin-left: 10px;"
                          ></v-switch>
                      </template>
                  </CadastroToolbar>
                </template>

                <template v-slot:item.p_dentro_rota="{ item }">
                  <PercentItem :value="item.p_dentro_rota"></PercentItem>
                </template>

                <template v-slot:item.p_viagens_validas="{ item }">
                  <PercentItem :value="item.p_viagens_validas"></PercentItem>
                </template>

            </merus-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
  
  <div ref="pdfdiv">
    <merus-data-table
        ref="viagensTable"
        :headers="headers"
        :items="viagensFiltered"
        sort-by="inicio"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loadingViagens"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-bottom: 10px;"
        cod-tabela="RELCUMPRIMENTOROTA"
        append-actions
        actions-i18n-key="table.actions"
        @update:headers="headers = $event"
    >
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('routeCompliance.tripsAndCompliance')"
                :token="token"
                :items="viagensFiltered"
                csv-title="cumprimentoderota"
                :csv-headers="headers"
                list-endpoint="getviagenscumprimentoderota"
                :request-params="csvExportRequestParams"
                :post-filters="csvExportPostFilters"
                :export-total="viagensFiltered.length"
                id-field="id_viagem_grid"
                :pdf-title="$t('routeCompliance.title')"
                :pdf-headers="headers"
                pdf-filename="cumprimentoderota"
                :pdf-subtitle="pdfsubtitle"
                hide-search
            />
        </template>

        <template v-slot:item.p_dentro_rota="{ item }">
            <PercentItem :value="item.p_dentro_rota"></PercentItem>
        </template>

        <template v-slot:item.temp_media="{ item }">
          {{ getWeatherTemp(item) }}
        </template>

        <template v-slot:item.condicao_climatica="{ item }">
          <v-icon :color="getWeatherIconColor(item)">{{ getWeatherIcon(item) }}</v-icon>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="orange" @click="abrirRelatorioViagem(item)"
              >mdi-clipboard-file</v-icon
            >
        </template>

      </merus-data-table>
    </div>
    </v-container>
  </template>
  
  <script>

import apiController from '@/utils/apiController';
import EventBus from "@/utils/eventBus";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import DateUtils from "../utils/dateutils";
import PercentItem from "./PercentItem.vue";
import DetalhesViagem from "./DetalhesViagem.vue";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import { inFilter, mergePostFilters, multiSearchToPostFilters } from '@/utils/csvExportPostFilters';

  export default {
    components: {
    MerusDataTable,
    CadastroToolbar,
    PercentItem,
    DetalhesViagem,
    MultiplaEscolha
},
    data: () => ({
    headers: [],
    headersAgregadoWithProperties: [],
      user: null,
      token: null,
      tab: 0,
      progressoDialog: false,
      showConfirmButton: true,

      mensagemProgressoDialog: "",
      formValidado: false,
      loadingViagens: false,
      loadingAgregadoLinhas: false,
      loadingAgregadoVeiculos: false,
      loadingAgregadoFuncionarios: false,

      headersAgregado: null,

      timeProps: {
        useSeconds: true,
      },
      porDia: false,
      dti: null,
      dtf: null,
      idEmpresaSelected:  null,
      idVeiculoSelected: [],
      idLinhaSelected: [],
      idFuncionarioSelected: [],
      empresas: [],
      unidadesSelecionadas: [],
      posicoes: [],
      viagens: [],
      viagensFiltered: [],
      agregado: [],
      agregadoVeiculos: [],
      agregadoFuncionarios: [],
      agregadoLinhas: [],
      agregadoVeiculosPorDia: [],
      agregadoFuncionariosPorDia: [],
      agregadoLinhasPorDia: [],
      config: null,
      dialogRelatorio: false,
      relatorioKey: 0,
      editedItem: {},
      /** Último body enviado a getviagenscumprimentoderota (export CSV/PDF via scheduler). */
      lastExportParams: null,
      csvPostFiltersRefreshTick: 0,
    }),
    computed: {
      semUnidadeOption() {
        return [
          {
            id_unidade: -1,
            descricao_unidade: 'Sem Unidade',
            cod_unidade: 'SU',
          },
        ];
      },
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      /** Fallback quando tabelas_front/RELCUMPRIMENTOROTA não está configurado no banco. */
      defaultHeaders() {
        return [
          { text: this.$t('operationSummary.vehiclesInOperation.vehicleId'), value: 'id_veiculo', align: ' d-none' },
          { text: this.$t('monitor.logbook.line'), value: 'cod_linha' },
          { text: this.$t('fields.vehicle'), value: 'numero_ordem' },
          { text: this.$t('monitor.trip.departure'), value: 'dt_inicio_extenso' },
          { text: this.$t('monitor.trip.arrival'), value: 'dt_fim_extenso' },
          { text: this.$t('operation.direction'), value: 'descricao_sentido' },
          { text: this.$t('operation.driverRegistration'), value: 'matricula_motorista' },
          { text: this.$t('operation.driverName'), value: 'nome_motorista' },
          { text: this.$t('operation.collectorRegistration'), value: 'matricula_cobrador' },
          { text: this.$t('operation.collectorName'), value: 'nome_cobrador' },
          { text: this.$t('routeCompliance.headers.temperature'), value: 'temp_media' },
          { text: this.$t('routeCompliance.headers.weather'), value: 'condicao_climatica' },
          { text: this.$t('routeCompliance.headers.onRoutePercentage'), value: 'p_dentro_rota', width: '10%' },
        ];
      },
      /** Mesmo body da última busca; reexecutado pelo worker de export. */
      csvExportRequestParams() {
        return this.lastExportParams && typeof this.lastExportParams === 'object'
          ? { ...this.lastExportParams }
          : {};
      },
      csvExportPostFilters() {
        void this.csvPostFiltersRefreshTick;
        const tableRef = this.$refs.viagensTable;
        const multiSearchFilters = tableRef ? multiSearchToPostFilters(tableRef.multiSearch) : {};
        return mergePostFilters(
          inFilter('id_linha', this.idLinhaSelected),
          inFilter('id_veiculo_realizado', this.idVeiculoSelected),
          inFilter('id_motorista_realizado', this.idFuncionarioSelected),
          multiSearchFilters
        );
      },
      unidadesSelecionadasIds() {
        return (this.unidadesSelecionadas || [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id) && (id > 0 || id === -1));
      },
      lazySelectRequestData() {
        const unidades = this.unidadesSelecionadasIds;
        if (unidades.length === 0) {
          return {};
        }
        // Uma linha pode estar em varias unidades: id_unidades cobre a selecao
        // multipla (getLinhaslazy trata -1 como "sem unidade"), enquanto
        // id_unidade atende os selects que so aceitam uma unidade.
        const requestData = { id_unidades: unidades };
        if (unidades.length === 1) {
          requestData.id_unidade = unidades[0];
        }
        return requestData;
      },
    pdfsubtitle() {
        if (!this.dti || !this.dtf) return '';
        return `${DateUtils.getDateSQLFormatted(this.dti)} — ${DateUtils.getDateSQLFormatted(this.dtf)}`;
      },
      headerPorDia() {
        return { text: this.$t('fields.date'), value: "dt_referencia_extenso" };
      },
      messageConfirmButton() {
        return this.$t('button.confirm');
      },
      messageDismissButton() {
        return this.$t('button.dismiss');
      },
      headersLinhas() {
        return [
        { text: this.$t('operationSummary.linesInOperation.lineId'), value: "id_linha", align: " d-none"},
        { text: this.$tc('line.self', 1), value: "cod_linha"},
        { text: this.$t('routeCompliance.headers.totalTrips'), value: "n_viagens_totais"},
        { text: this.$t('routeCompliance.headers.validTrips'), value: "n_viagens_validas"},
        { text: this.$t('routeCompliance.headers.onRoutePercentage'), value: "p_dentro_rota", width: "30%"},
        { text: this.$t('routeCompliance.headers.validTripsPercentage'), value: "p_viagens_validas", width: "30%"}
        ];
      },
      headersVeiculos() {
        return [
        { text: this.$t('operationSummary.vehiclesInOperation.vehicleId'), value: "id_veiculo", align: " d-none"},
        { text: this.$t('nav.registration.vehicles'), value: "numero_ordem"},
        { text: this.$t('routeCompliance.headers.totalTrips'), value: "n_viagens_totais"},
        { text: this.$t('routeCompliance.headers.validTrips'), value: "n_viagens_validas"},
        { text: this.$t('routeCompliance.headers.onRoutePercentage'), value: "p_dentro_rota", width: "30%"},
        { text: this.$t('routeCompliance.headers.validTripsPercentage'), value: "p_viagens_validas", width: "30%"}
        ];
      },
      headersFuncionarios() {
        return [
        { text: this.$t('routeCompliance.headers.employeeId'), value: "id_funcionario_motorista", align: " d-none"},
        { text: this.$t('operationSummary.linesInOperation.lineName'), value: "nome"},
        { text: this.$t('routeCompliance.headers.totalTrips'), value: "n_viagens_totais"},
        { text: this.$t('routeCompliance.headers.validTrips'), value: "n_viagens_validas"},
        { text: this.$t('routeCompliance.headers.onRoutePercentage'), value: "p_dentro_rota", width: "30%"},
        { text: this.$t('routeCompliance.headers.validTripsPercentage'), value: "p_viagens_validas", width: "30%"}
        ];
      },
      loadingAgregado() {
        return this.loadingAgregadoLinhas || this.loadingAgregadoVeiculos || this.loadingAgregadoFuncionarios;
      },
      yesterday() {
        let td = new Date();
        td.setDate(td.getDate() - 1);
        return td.toISOString().substring(0,10);
      },
      dtiProps() {
        return {
          max: this.yesterday
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min
        }
      },
      textFieldProps() {
        return {
          prependIcon: "mdi-calendar"
        }
      },
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
        this.headers = this.defaultHeaders;
        this.buildHeader();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.headers = this.defaultHeaders;
      this.initialize();
      this.buildHeader();
    },
    mounted() {
      this.$nextTick(() => { this.csvPostFiltersRefreshTick++; });
    },
    methods: {

      // A API ja aplica escopo do usuario, empresa e unidades; aqui so protegemos
      // contra resposta inesperada.
      dadosDaResposta(response) {
        return Array.isArray(response && response.data) ? response.data : [];
      },
      filtraItensLazyParaIds(dados) {
        if (!dados || !Array.isArray(dados)) {
          return [];
        }
        let filtrados = dados;
        if (this.idEmpresaSelected) {
          filtrados = filtrados.filter((d) => d.id_empresa == this.idEmpresaSelected);
        } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
          filtrados = filtrados.filter((d) => d.id_cliente == this.user.id_cliente);
        }
        if (this.unidadesSelecionadas.length > 0) {
          const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
          filtrados = filtrados.filter((d) => {
            if (Array.isArray(d.unidades) && d.unidades.length > 0) {
              return d.unidades.map((id) => Number(id)).some((u) => selecionadas.includes(u));
            }
            if (d.id_unidade != null && d.id_unidade !== '') {
              return selecionadas.includes(Number(d.id_unidade));
            }
            if (d.id_linha != null && d.id_veiculo == null && d.id_funcionario == null) {
              return true;
            }
            return selecionadas.includes(-1);
          });
        }
        return filtrados;
      },
      async resolveLazySelectIds(refName, selectedIds, valueKey) {
        if (Array.isArray(selectedIds) && selectedIds.length > 0) {
          return { ids: selectedIds, implicit: false };
        }
        const selectRef = this.$refs[refName];
        if (!selectRef || typeof selectRef.fetchAllLazyItems !== 'function') {
          return { ids: [], implicit: true };
        }
        const { items } = await selectRef.fetchAllLazyItems({
          search: '',
          requestDataOverride: this.lazySelectRequestData,
        });
        const ids = this.filtraItensLazyParaIds(items || [])
          .map((item) => item[valueKey])
          .filter((id) => id != null && id !== '');
        return { ids, implicit: true };
      },
      limparResultadosRelatorio() {
        this.viagens = [];
        this.viagensFiltered = [];
        this.agregadoVeiculos = [];
        this.agregadoFuncionarios = [];
        this.agregadoLinhas = [];
        this.agregadoVeiculosPorDia = [];
        this.agregadoFuncionariosPorDia = [];
        this.agregadoLinhasPorDia = [];
      },
      initialize() {
        this.getConfig();
        this.populaEmpresas();
      },
      populaEmpresas() {
        apiController.request(apiController.endpoints.getallEmpresas, {
          silent: true,
          onSuccess: (response) => {
            this.empresas = response.data;
          },
          onError: (e) => {
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          }
        });
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
            silent: true,
            onSuccess: (response) => {
              this.config = response.data[0];
              [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
            },
            onError: (e) => {
              console.log("Response : " + e.message);
              if (e.message == "Request failed with status code 401") {
                EventBus.$emit('show-error', { error: e });
              }
            }
          });
        },
      populaViagens(params) {
        this.loadingViagens = true;

        apiController.request(apiController.endpoints.getViagenscumprimentoderota, {
          data: params,
          silent: true,
          onSuccess: (response) => {
            this.viagens = this.dadosDaResposta(response);
            this.viagensFiltered = this.viagens;
            this.loadingViagens = false;
          },
          onError: (e) => {
            this.loadingViagens = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
              this.autorizacaoDialog = true;
            }
          }
        });

      },
      populaAgregadoLinhas(body) {
        this.loadingAgregadoLinhas = true;
        let params = {...body, grupo: "linha"};

        apiController.request(apiController.endpoints.getViagenscumprimentoderotaagregado, {
          data: params,
          silent: true,
          onSuccess: (response) => {
            this.agregadoLinhas = this.dadosDaResposta(response);
            this.populaAgregadoLinhasPorDia(params);
          },
          onError: (e) => {
            this.loadingAgregadoLinhas = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          }
        });
      },
      populaAgregadoLinhasPorDia(body) {
        let params = {...body, por_dia: true};

        apiController.request(apiController.endpoints.getViagenscumprimentoderotaagregado, {
          data: params,
          silent: true,
          onSuccess: (response) => {
            this.agregadoLinhasPorDia = this.dadosDaResposta(response);
            this.buildHeader();
            this.loadingAgregadoLinhas = false;
          },
          onError: (e) => {
            this.loadingAgregadoLinhas = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          }
        });
      },
      populaAgregadoVeiculos(body) {
        this.loadingAgregadoVeiculos = true;
        let params = {...body, grupo: "veiculo"}

        apiController.request(apiController.endpoints.getViagenscumprimentoderotaagregado, {
          data: params,
          silent: true,
          onSuccess: (response) => {
            this.agregadoVeiculos = this.dadosDaResposta(response);
            this.populaAgregadoVeiculosPorDia(params);
          },
          onError: (e) => {
            this.loadingAgregadoVeiculos = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          }
        });
      },
      populaAgregadoVeiculosPorDia(body) {
        let params = {...body, por_dia: true};

        apiController.request(apiController.endpoints.getViagenscumprimentoderotaagregado, {
          data: params,
          silent: true,
          onSuccess: (response) => {
            this.agregadoVeiculosPorDia = this.dadosDaResposta(response);
            this.buildHeader();
            this.loadingAgregadoVeiculos = false;
          },
          onError: (e) => {
            this.loadingAgregadoVeiculos = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          }
        });
      },
      populaAgregadoFuncionarios(body) {
        this.loadingAgregadoFuncionarios = true;
        let params = {...body, grupo: "funcionario"}

        apiController.request(apiController.endpoints.getViagenscumprimentoderotaagregado, {
          data: params,
          silent: true,
          onSuccess: (response) => {
            this.agregadoFuncionarios = this.dadosDaResposta(response);
            this.populaAgregadoFuncionariosPorDia(params);
          },
          onError: (e) => {
            this.loadingAgregadoVeiculos = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          }
        });
      },
      populaAgregadoFuncionariosPorDia(body) {
        let params = {...body, por_dia: true};

        apiController.request(apiController.endpoints.getViagenscumprimentoderotaagregado, {
          data: params,
          silent: true,
          onSuccess: (response) => {
            this.agregadoFuncionariosPorDia = this.dadosDaResposta(response);
            this.buildHeader();
            this.loadingAgregadoFuncionarios = false;
          },
          onError: (e) => {
            this.loadingAgregadoFuncionarios = false;
            console.log(this.$t('system.messages.errorAxios'));
            console.log(e.message);
            if (e.message == "Request failed with status code 401") {
              EventBus.$emit('show-error', { error: e });
            }
          }
        });
      },
      populaAgregados(body) {
        this.populaAgregadoLinhas(body);
        this.populaAgregadoVeiculos(body);
        this.populaAgregadoFuncionarios(body);
      },
      async populaRelatorio() {
        this.$refs.form.validate();
        if (!this.formValidado) {
          return;
        }

        this.limparResultadosRelatorio();
        this.progressoDialog = true;
        this.mensagemProgressoDialog = this.$t('operation.search');

        let idlinhas;
        let idveiculos;
        let idfuncionarios;
        let linhasImplicit = true;
        let veiculosImplicit = true;
        let funcionariosImplicit = true;
        try {
          const [linhasRes, veiculosRes, funcionariosRes] = await Promise.all([
            this.resolveLazySelectIds('linhasSelect', this.idLinhaSelected, 'id_linha'),
            this.resolveLazySelectIds('veiculosSelect', this.idVeiculoSelected, 'id_veiculo'),
            this.resolveLazySelectIds('funcionariosSelect', this.idFuncionarioSelected, 'id_funcionario'),
          ]);
          idlinhas = linhasRes.ids;
          idveiculos = veiculosRes.ids;
          idfuncionarios = funcionariosRes.ids;
          linhasImplicit = !!linhasRes.implicit;
          veiculosImplicit = !!veiculosRes.implicit;
          funcionariosImplicit = !!funcionariosRes.implicit;
        } catch (_err) {
          this.progressoDialog = false;
          return;
        } finally {
          this.progressoDialog = false;
        }

        const dataInicial = DateUtils.getDateSQLFormatted(this.dti);
        const dataFinal = DateUtils.getDateSQLFormatted(this.dtf);
        // Sem seleção explícita: null (sem filtro IN), igual ao relatório extenso.
        const temp = {
          idlinhas: linhasImplicit ? null : (idlinhas && idlinhas.length ? idlinhas : null),
          idveiculos: veiculosImplicit ? null : (idveiculos && idveiculos.length ? idveiculos : null),
          idfuncionarios: funcionariosImplicit ? null : (idfuncionarios && idfuncionarios.length ? idfuncionarios : null),
          dti: dataInicial,
          dtf: dataFinal,
          idempresa: this.idEmpresaSelected || null,
          idunidades: this.unidadesSelecionadasIds,
          idcliente: this.idEmpresaSelected ? null : (this.user && this.user.id_cliente != null && this.user.id_cliente !== '' ? this.user.id_cliente : null),
        };
        this.lastExportParams = { ...temp };
        this.populaViagens(temp);
        this.populaAgregados(temp);
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      },
      getTempoPlacaTotal() {
        return this.getTempoFormatted(this.viagensFiltered.reduce((total,viagem) => total + viagem.tempo_de_placa, 0));
      },
      getWeatherIcon(item) {
        if (!item.condicao_climatica) {
          return null;
        }
        return item.condicao_climatica === this.$t('routeCompliance.rain') ? "mdi-weather-rainy" : "mdi-weather-sunny"
      },
      getWeatherIconColor(item) {
        if (!item.condicao_climatica) {
          return null;
        }
        return item.condicao_climatica === this.$t('routeCompliance.rain') ? "blue" : "orange"
      },
      getWeatherTemp(item) {
        if (!item.temp_media) {
          return null;
        }
        return `${item.temp_media} °C`;
      },
      buildHeader() {
        let tabHeaders = [];
        if (this.tab === 0) {
          if (this.porDia) {
            this.agregado = this.agregadoVeiculosPorDia;
            tabHeaders.push(this.headerPorDia);
          } else {
            this.agregado = this.agregadoVeiculos;
          }
          tabHeaders.push(...this.headersVeiculos);
        } else if (this.tab === 1) {
          if (this.porDia) {
            this.agregado = this.agregadoLinhasPorDia;
            tabHeaders.push(this.headerPorDia);
          } else {
            this.agregado = this.agregadoLinhas;
          }
          tabHeaders.push(...this.headersLinhas);
        } else if (this.tab === 2) {
          if (this.porDia) {
            this.agregado = this.agregadoFuncionariosPorDia;
            tabHeaders.push(this.headerPorDia);
          } else {
            this.agregado = this.agregadoFuncionarios;
          }
          tabHeaders.push(...this.headersFuncionarios)
        }
        this.headersAgregado = tabHeaders;
        this.headersAgregadoWithProperties = tabHeaders.map((header) => ({
          ...header,
          filtrable: true,
          sortable: true,
        }));
      },
      togglePorDia() {
        this.buildHeader();
      },
      abrirRelatorioViagem(viagem) {
        this.editedItem = Object.assign({}, viagem);
        this.relatorioKey === 0 ? this.relatorioKey = 1 : this.relatorioKey = 0;
        this.dialogRelatorio = true;
      },
      closeRelatorio() {
        this.editedItem = Object.assign({}, {});
        this.dialogRelatorio = false;
      },
    },
  };
  </script>